import {IUserPaymentMethod, IUserPaymentMethodCreate} from "../config/user_payment_method";
import {IMuiSelectOption} from "../config/mui";
import {INewPaymentMethodState} from "../components/Settings/UserPaymentMethods/Actions/NewAction";
import { DueDateType } from "../config/due_date";

export const transformToMuiSelectFormat = (data: IUserPaymentMethod[]): IMuiSelectOption[] => {
    return data.map(({id, name}) => {
        return {value: id, label: name};
    });
};

export const toFormRequest = (input: INewPaymentMethodState): IUserPaymentMethodCreate => {
    const data = {} as IUserPaymentMethodCreate;
    if (!!input.paymentMethodId) {
        data.payment_method_id = parseInt(input.paymentMethodId);
    }
    if (!!input.name) {
        data.name = input.name;
    }
    if (!!input.dueType) {
        data.due_type = input.dueType;

        if (!!input.dueDay && input.dueType === DueDateType.DAY_OF_THE_MONTH) {
            data.due_day = parseInt(input.dueDay);
        } else if (
            input.dueDaysOffset &&
            (
                input.dueType === DueDateType.X_AMOUNT_OF_DAYS ||
                input.dueType === DueDateType.X_DAYS_AFTER_END_OF_MONTH ||
                input.dueType === DueDateType.BUSINESS_DAYS_AFTER
            )
        ) {
            data.due_days_offset = parseInt(input.dueDaysOffset);
        }
    }

    return data;
};
